var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultilineTextActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44973_243824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.8672 1.16016H4.86719C2.65805 1.16016 0.867188 2.95102 0.867188 5.16016V68.1602C0.867188 70.3693 2.65805 72.1602 4.86719 72.1602H67.8672C70.0763 72.1602 71.8672 70.3693 71.8672 68.1602V5.16016C71.8672 2.95102 70.0763 1.16016 67.8672 1.16016Z",
    fill: "#146EB4",
    fillOpacity: 0.1,
    stroke: "#146EB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8672 56.6602H10.8672C10.591 56.6602 10.3672 56.884 10.3672 57.1602C10.3672 57.4363 10.591 57.6602 10.8672 57.6602H61.8672C62.1433 57.6602 62.3672 57.4363 62.3672 57.1602C62.3672 56.884 62.1433 56.6602 61.8672 56.6602Z",
    fill: "#146EB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3672 32.3867H62.3672",
    stroke: "#146EB4",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3672 38.3867H62.3672",
    stroke: "#146EB4",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3672 44.3867H62.3672",
    stroke: "#146EB4",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1065 17.6602C39.7568 17.6602 40.2921 18.1407 40.3606 18.758L40.368 18.8923V23.7414C40.368 24.4219 39.8032 24.9736 39.1065 24.9736C38.4563 24.9736 37.9209 24.493 37.8524 23.8757L37.845 23.7414L37.844 20.1244H13.8901V23.7414C13.8901 24.3766 13.3982 24.8995 12.7661 24.9664L12.6287 24.9736C11.9784 24.9736 11.4431 24.493 11.3746 23.8757L11.3672 23.7414V18.8923C11.3672 18.2572 11.8592 17.7343 12.4912 17.6674L12.6287 17.6602H39.1065Z",
    fill: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8323 43.5234C31.529 43.5234 32.0937 44.0751 32.0937 44.7556C32.0937 45.3907 31.6018 45.9136 30.9697 45.9805L30.8323 45.9877H20.9031C20.2064 45.9877 19.6416 45.4361 19.6416 44.7556C19.6416 44.1205 20.1336 43.5976 20.7656 43.5307L20.9031 43.5234H30.8323Z",
    fill: "#146EB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8674 17.6602C26.5177 17.6602 27.053 18.1407 27.1215 18.758L27.1289 18.8923V44.7544C27.1289 45.4349 26.5641 45.9865 25.8674 45.9865C25.2172 45.9865 24.6818 45.506 24.6134 44.8886L24.606 44.7544V18.8923C24.606 18.2118 25.1707 17.6602 25.8674 17.6602Z",
    fill: "#146EB4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1065 17.6602C39.7568 17.6602 40.2921 18.1407 40.3606 18.758L40.368 18.8923V23.7414C40.368 24.4219 39.8032 24.9736 39.1065 24.9736C38.4563 24.9736 37.9209 24.493 37.8524 23.8757L37.845 23.7414L37.844 20.1244H13.8901V23.7414C13.8901 24.3766 13.3982 24.8995 12.7661 24.9664L12.6287 24.9736C11.9784 24.9736 11.4431 24.493 11.3746 23.8757L11.3672 23.7414V18.8923C11.3672 18.2572 11.8592 17.7343 12.4912 17.6674L12.6287 17.6602H39.1065Z",
    fill: "#146EB4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8323 43.5234C31.529 43.5234 32.0937 44.0751 32.0937 44.7556C32.0937 45.3907 31.6018 45.9136 30.9697 45.9805L30.8323 45.9877H20.9031C20.2064 45.9877 19.6416 45.4361 19.6416 44.7556C19.6416 44.1205 20.1336 43.5976 20.7656 43.5307L20.9031 43.5234H30.8323Z",
    fill: "#146EB4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8674 17.6602C26.5177 17.6602 27.053 18.1407 27.1215 18.758L27.1289 18.8923V44.7544C27.1289 45.4349 26.5641 45.9865 25.8674 45.9865C25.2172 45.9865 24.6818 45.506 24.6134 44.8886L24.606 44.7544V18.8923C24.606 18.2118 25.1707 17.6602 25.8674 17.6602Z",
    fill: "#146EB4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44973_243824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0.367188 0.660156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultilineTextActive);
export default __webpack_public_path__ + "static/media/multiline-text-active.c6b11ebfd65f6764f476807ae0a53d20.svg";
export { ForwardRef as ReactComponent };